export default "__VITE_ASSET__DClU6q9P__"